// searchAmazonItems.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { ErrorResponse } from 'react-router-dom';
import { ApiEndPoints } from '../api-path';
import { getAPIConfig } from '../services/get-api-config';

// 👇 Thunk to fetch Amazon items based on search query

export const searchAmazonItems = createAsyncThunk(
    'amazon/searchAmazonItems',
    async (keyword: string, thunkApi) => {
        try {
            const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.SearchAmazonItems}?keyword=${encodeURIComponent(keyword)}`;
            const response = await axios.get(url, await getAPIConfig());

            const data = response.data;
            // ✅ CASE 1: If backend returns a proper response object
            if (data && typeof data === 'object' && !Array.isArray(data) && data.status === 200) {
                return thunkApi.fulfillWithValue(data);
            }
            // ✅ CASE 2: If backend returns array directly (no status/message)
            if (Array.isArray(data)) {
                return thunkApi.fulfillWithValue({
                    status: 200,
                    data: data,
                    message: 'Success',
                });
            }

            // ❌ Anything else is treated as error
            return thunkApi.rejectWithValue(data || { message: 'Unexpected response structure' });
        } catch (error) {
            const err = error as AxiosError<ErrorResponse>;
            if (err.response?.data) {
                return thunkApi.rejectWithValue(err.response.data);
            }
            return thunkApi.rejectWithValue({ message: 'Something went wrong' });
        }
    }
);